export const name = "NET.SAFE_IP_FROM_STRING";
export const summary = `Similar to the \`NET.IP_FROM_STRING\`, but returns \`NULL\` instead of producing an error if the input is invalid.`;
export const reference = `
## NET.SAFE_IP_FROM_STRING

Similar to the \`NET.IP_FROM_STRING\`, but returns \`NULL\` instead of producing an error if the input is invalid.

\`\`\`
NET.SAFE_IP_FROM_STRING(addr_str)
\`\`\`

### Description

Similar to \`NET.IP_FROM_STRING\`, but returns \`NULL\`instead of throwing an error if the input is invalid.


### Return Data Type

BYTES


### Example



\`\`\`
SELECT
  addr_str,
  FORMAT("%T", NET.SAFE_IP_FROM_STRING(addr_str)) AS safe_ip_from_string
FROM UNNEST([
  '48.49.50.51',
  '::1',
  '3031:3233:3435:3637:3839:4041:4243:4445',
  '::ffff:192.0.2.128',
  '48.49.50.51/32',
  '48.49.50',
  '::wxyz'
]) AS addr_str;

/*---------------------------------------------------------------------------------------------------------------*
 | addr_str | safe_ip_from_string |
 +---------------------------------------------------------------------------------------------------------------+
 | 48.49.50.51 | b"0123" |
 | ::1 | b"\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x01" |
 | 3031:3233:3435:3637:3839:4041:4243:4445 | b"0123456789@ABCDE" |
 | ::ffff:192.0.2.128 | b"\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\xff\\xff\\xc0\\x00\\x02\\x80" |
 | 48.49.50.51/32 | NULL |
 | 48.49.50 | NULL |
 | ::wxyz | NULL |
 *---------------------------------------------------------------------------------------------------------------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/net_functions
`;
